import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../components/ConfigurableSvg/components/Container.js';
export const Discount = ({
  badgeColor,
  textColor,
  value,
  rotateRight
}) => _jsx(Container, {
  rotate: rotateRight,
  children: _jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 250",
    children: [_jsx("defs", {
      children: _jsxs("linearGradient", {
        id: "BRAND_GRADIENT",
        x1: "231",
        y1: "224.07",
        x2: "70.2",
        y2: "32.44",
        gradientTransform: "translate(-14.12 19.22) rotate(-7)",
        gradientUnits: "userSpaceOnUse",
        children: [_jsx("stop", {
          stopColor: "#F6AD2C"
        }), _jsx("stop", {
          offset: "0.0859245",
          stopColor: "#F5A62E"
        }), _jsx("stop", {
          offset: "0.207",
          stopColor: "#F39435"
        }), _jsx("stop", {
          offset: "0.3488",
          stopColor: "#EE763F"
        }), _jsx("stop", {
          offset: "0.5054",
          stopColor: "#E84C4E"
        }), _jsx("stop", {
          offset: "0.5166",
          stopColor: "#E8494F"
        }), _jsx("stop", {
          offset: "0.5849",
          stopColor: "#E8494F"
        }), _jsx("stop", {
          offset: "1",
          stopColor: "#E8494F"
        })]
      })
    }), _jsxs("g", {
      children: [_jsx("g", {
        id: "_9BNCyb",
        children: _jsx("path", {
          fill: "url(#BRAND_GRADIENT)",
          d: "M201.79,30.68c32.16,13.85,62.84,40.24,71.15,74.52,9.52,39.24-4.31,78.8-27.35,104.8-29.22,34.78-91.14,33.11-133.07,18.79-12.87-4.39-22.59-8.19-33.56-14.89-10.43-6.37-15.3-11.76-19.85-15.16-23.61-17.63-36.53-48.53-34.09-83.98,1.34-19.52,8.76-34.67,17.91-50.1,4.26-7.17,9.17-12.88,14.26-19.08,4.32-5.26,9.48-10.1,15.01-14.45,36.88-29.03,81.77-23.26,129.58-.45Z"
        })
      }), _jsx("path", {
        fill: `${badgeColor}`,
        d: "M113.12,27.81c36.91-9.19,66.01-7.9,94.12,3.51,30.69,12.46,50.31,34.68,57.46,67.73,3.9,18.06,4.7,35.97,.62,53.82-6.81,29.81-26.83,48.7-53.55,61.18-34.99,16.34-71.49,19.27-108.84,10.09-17.2-4.22-33.26-11.34-46.94-22.95-18.43-15.65-25.53-36.32-25.86-59.8-.42-29.79,8.06-56.75,27.64-79.38,16.57-19.15,38.28-30.23,55.35-34.21Z"
      })]
    }), _jsxs("text", {
      fontSize: "70px",
      fontWeight: "bold",
      fill: `${textColor}`,
      transform: "translate(75.82 151.31) rotate(-7.15)",
      children: [_jsx("tspan", {
        x: "10",
        y: "8",
        children: value
      }), _jsx("tspan", {
        x: "92",
        y: "8",
        children: "%"
      })]
    }), _jsxs("g", {
      children: [_jsx("text", {
        fill: `${textColor}`,
        transform: "translate(85.3 188.58) rotate(-7.15)",
        children: _jsx("tspan", {
          fontSize: "31px",
          x: "20",
          y: "5",
          children: "sparen"
        })
      }), _jsx("text", {
        fontSize: "31px",
        fill: `${textColor}`,
        transform: "translate(103.53 84.96) rotate(-7.15)",
        children: _jsx("tspan", {
          x: "0",
          y: "0",
          children: "Bis zu"
        })
      })]
    }), _jsx("g", {
      width: "100px",
      height: "100px",
      transform: "translate(-30, -55) scale(2.2)",
      children: _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M80.8545 119.306C80.8545 115.626 83.8412 112.64 87.5212 112.64C91.2012 112.64 94.1878 115.626 94.1878 119.306C94.1878 122.986 91.2012 125.973 87.5212 125.973C83.8412 125.973 80.8545 122.986 80.8545 119.306ZM82.1878 119.306C82.1878 122.246 84.5812 124.64 87.5212 124.64C90.4612 124.64 92.8545 122.246 92.8545 119.306C92.8545 116.366 90.4612 113.973 87.5212 113.973C84.5812 113.973 82.1878 116.366 82.1878 119.306ZM88.1878 121.973V123.306H86.8545V121.973H88.1878ZM84.9745 117.193C85.3412 115.98 86.5545 115.133 87.9278 115.333C89.0878 115.506 90.0012 116.486 90.1612 117.646C90.3132 118.722 89.7183 119.241 89.1441 119.742C89.0386 119.834 88.9338 119.925 88.8345 120.02C88.7545 120.093 88.6812 120.166 88.6145 120.246C88.6112 120.25 88.6078 120.255 88.6045 120.26C88.6012 120.265 88.5978 120.27 88.5945 120.273C88.5278 120.353 88.4612 120.44 88.4078 120.533C88.4012 120.543 88.3962 120.553 88.3912 120.563C88.3862 120.573 88.3812 120.583 88.3745 120.593C88.2612 120.793 88.1878 121.026 88.1878 121.306H86.8545C86.8545 120.973 86.9078 120.7 86.9878 120.473C86.9907 120.464 86.9924 120.457 86.9939 120.45C86.9958 120.441 86.9974 120.434 87.0012 120.426C87.0045 120.416 87.0095 120.408 87.0145 120.4C87.0195 120.391 87.0245 120.383 87.0278 120.373C87.0745 120.253 87.1345 120.14 87.1945 120.04C87.1978 120.033 87.2012 120.028 87.2045 120.023C87.2078 120.018 87.2112 120.013 87.2145 120.006C87.2145 120.003 87.2162 120.001 87.2178 120C87.2195 119.998 87.2212 119.996 87.2212 119.993C87.4482 119.651 87.7527 119.417 88.0375 119.198C88.4467 118.883 88.8152 118.6 88.8545 118.073C88.9078 117.426 88.4412 116.806 87.8078 116.673C87.1212 116.526 86.4878 116.933 86.2745 117.526C86.1812 117.78 85.9612 117.973 85.6878 117.973H85.5545C85.1478 117.973 84.8545 117.58 84.9745 117.193Z",
        fill: textColor
      })
    })]
  })
});